export default "__VITE_ASSET__C3yfE9vc__"